<template>
  <section class="content">
    <div>
      <div class="box-body">
        <!-- v-permission.if="['addCity']" -->
        <div :class="addButtonClass">
          <router-link
            :to="{ name: 'transportPointCreate', params: { _id: '0' } }"
          >
            <button class="btn gradientbt">Add Transfer Point</button>
          </router-link>
        </div>

        <v-server-table
          ref="transportTable"
          url
          :limit="5"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="beforeBody">
            <tr v-if="loading" class="VueTables__no-results">
              <td class="text-center" colspan="6">
                <pulse-loader></pulse-loader>
              </td>
            </tr>
          </template>
          <template slot="action" slot-scope="props">
            <div class="active_wrp">
              <a
                class="fa fa-edit"
                role="button"
                v-on:click.stop="action(props.row)"
              ></a>

              <div class="py-2 text-center row">
                <label class="toggle">
                  <input
                    class="toggle-checkbox"
                    type="checkbox"
                    :checked="props.row.isActive"
                    @click.prevent="
                      (e) => activateTransportPointModal(props.row)
                    "
                  />
                  <span class="slider"></span>
                  <span
                    class="labels"
                    data-on="Active"
                    data-off="Deactivate"
                  ></span>
                </label>
              </div>
            </div>
          </template>

          <!-- <template>
                    <div class="form-group col-md-2">
                      <select
                        @change="applyFilter(custom_filter_select)"
                        class="form-control"
                      >
                        <option v-for="value in custom_filter_options" :key="value">{{value}}</option>
                      </select>
                    </div>
                    <button class="btn btn-default inline" @click="clearFilter('')">clear</button>
                  </template> -->
        </v-server-table>
      </div>
    </div>
  </section>
</template>

<script>
import { eventBus, transportService } from "../../../services";
import { USER_ROLES } from "../../../config";
import { ServerTable, Event } from "vue-tables-2";
import { mapState } from "vuex";

import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";
import dateFormatter from "../../utilities/dateFormate";

export default {
  name: "transport",
  data() {
    return {
      loading: null,
      USER_ROLES: USER_ROLES,
      transportTable: null,
      columns: [
        "cityName",
        "transportName",
        "transportLocation",
        "createdAt",
        "action",
      ],
      // custom_filter_options: ['Active', 'Inactive','status'],
      // custom_filter_select: '',
      options: {
        highlightMatches: true,
        headings: {
          cityName: "City",
          transportName: "TP Name",
          transportLocation: "Location",
          createdAt: "Created On",
          action: "Action",
        },
        templates: {
          createdAt(row, query) {
            return dateFormatter(query.createdAt);
            // return moment(query.createdAt).format("DD-MM-YYYY");
          },
        },
        perPage: 10,
        sortable: ["transportName", "transportLocation", "createdAt"],
        requestFunction: (request) => {
          const params = {};
          params.page = request.page;
          params.limit = request.limit;
          if (request.orderBy) {
            params.sortBy = request.orderBy;
          }
          if (request.ascending == 1) {
            params.sortOrder = "asc";
          } else {
            params.sortOrder = "des";
          }
          if (request.query.status) {
            params.status = request.query.status;
          }
          if (request.query) {
            params.searchString = request.query;
          }

          this.loading = true;
          return this.$transportDataRepository
            .collectionTransportList(params)
            .catch((error) => {
              console.error("Transport.requestFunction-error:", error);
            });
        },

        responseAdapter: (response) => {
          this.loading = false;
          let transportResponse = [];
          let count;
          response.data.response.forEach((element) => {
            var transportData = element;
            // transportData['cityName'] = element.cityId != null ? element.cityId.cityName : null;
            transportResponse.push(transportData);
          });
          if (transportResponse.length === 0) {
            count = 0;
          }
          return {
            data: transportResponse,
            count: response.data.items.total || 0,
          };
        },

        customFilters: [
          {
            name: "custom_filter",
            callback: function(row, query) {
              //	return row.role[0] == query;
            },
          },
        ],
        uniqueKey: "_id",
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.transportTable) {
        return this.transportTable.count > this.transportTable.limit ||
          this.transportTable.limit > 10
          ? "shift-add-left"
          : "add-item";
      } else {
        return "add-item";
      }
    },
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    activateTransportPointModal(row) {
      let confirmtext;
      if (row.isActive === true) {
        confirmtext = "Deactivate";
      } else {
        confirmtext = "Activate";
      }
      swal({
        // title: "Are you sure?",
        title: `Are you sure you want to ${confirmtext}?`,
        // text: `Are you sure you want to ${confirmtext}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0f6940",
        cancelButtonColor: "#d33",
        confirmButtonText: `Yes, ${confirmtext}`,
      }).then((result) => {
        if (result.value) {
          this.activateTransportPoint(row);
        }
      });
    },
    activateTransportPoint(row) {
      let confirmtext;
      if (row.isActive === true) {
        confirmtext = "Deactivate";
      } else {
        confirmtext = "Activate";
      }
      this.loading = true;
      return transportService
        .updateTransportPointStatus(row._id, !row.isActive)
        .then((response) => {
          this.loading = false;
          row.isActive = !row.isActive;
          this.$snotify.success(
            `The ${row.transportName} has been marked ${confirmtext}.`
          );
        })
        .catch((error) => {
          this.loading = false;
          console.error("TransportPoint.activateTransportPoint-error:", error);
          this.$snotify.error("Activate Transport failed", "Error!");
        });
    },

    action(row) {
      this.$router.push({
        name: "transportPointCreate",
        params: {
          _id: row._id,
        },
        props: row,
      });
      // getCurrentLoggedinUserRank() {
      //     return store.state.auth.user.role.rank;
      // },
      // rowClick(data) {
      //     // if (store.state.auth.user.role.rank <= data.row.role.rank) {
      //     this.$router.push({
      //         name: 'transportPointCreate',
      //         params: {
      //             _id: data.row._id,
      //         },
      //         props: data.row,
      //     });
      // } else {
      //     this.$snotify.error('You can`t update this user', 'Access Denied!');
      // }
    },
    onLoaded() {
      this.transportTable = this.$refs.transportTable;
    },
    clearFilter() {
      this.custom_filter_select = "";
    },
    applyFilter(filter_val) {
      Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
    },
  },
  mounted() {
    if (this.$store.state.auth.user.role.key === "superAdmin") {
      this.options.sortable.push("cityName");
    }
    eventBus.$on("DATA_PUBLISHED", (payload) => {});
  },
};
</script>

<style>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 200px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
  background: #0f6940;
  color: white;
}

.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #ccc;
  border-radius: 16px;
  width: 48px;
  height: 21px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
  content: "";
}

.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 15px;
  height: 15px;
  position: absolute;
  top: 3px;
  left: 4px;
  transition: left 0.25s;
}

.active_wrp {
  display: flex;
  align-items: center;
}

.active_wrp a {
  flex: 0 0 30%;
  color: #0f6940;
  margin-right: 5px;
}

.gradientbt:hover {
  color: #0f6940;
  background: #fff;
  border: 2px solid #0f6940;
}

.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}

.toggle-checkbox:checked + .toggle-switch {
  background: #0f6940;
}

.toggle-checkbox:checked + .toggle-switch:before {
  left: 30px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}

/* new css */

.toggle {
  --width: 64px;
  --height: calc(var(--width) / 3);

  position: relative;
  display: inline-block;
  width: var(--width);
  height: var(--height);
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: var(--height);
  cursor: pointer;
  margin-bottom: 0px;
  position: relative;
  top: 2px;
}

.toggle input {
  display: none;
}

.toggle .slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: var(--height);
  background-color: #ccc;
  transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: calc(var(--height));
  height: calc(var(--height));
  border-radius: calc(var(--height) / 2);
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked + .slider {
  background-color: #0f6940;
}

.toggle input:checked + .slider::before {
  transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
  position: absolute;
  top: 4px;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 10px;
  font-family: sans-serif;
  transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
  content: attr(data-off);
  position: absolute;
  right: 5px;
  color: #4d4d4d;
  opacity: 1;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
  content: attr(data-on);
  position: absolute;
  left: 5px;
  color: #ffffff;
  opacity: 0;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
  transition: all 0.4s ease-in-out;
}

.toggle input:checked ~ .labels::after {
  opacity: 0;
}

.toggle input:checked ~ .labels::before {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// transport.vue?1eab0370